import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { getVendorsListUrl, getVendorsRouterPath, useVendorsRoute } from './routes';
import VendorsListPage from './List';
import VendorProfile from './show/VendorProfile';
import VendorSecurityContext from './VendorSecurityContext';
import { FINANCE_VENDOR_LIST_READ, VENDOR_COMPLIANCE_REVIEW, VENDOR_FINALIZE, VENDOR_READ } from './constants';
import ComplianceVendorPage from './ComplianceVendor/ComplianceVendorPage';
import AgreementVendorPage from './AgreementVendor/AgreementVendorPage';
import { READ_VENDOR_DOCUMENTS } from './VendorTabs/vendorDocuments/useVendorDocumentsService';
import VendorDocumentContextTemplate from './VendorTabs/vendorDocuments/VendorDocumentContextTemplate';

const VendorRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    complianceRoute,
    agreementRoute,
    timelineRoute,
    documentsRoute,
    agreementsRoute,
    relatedInvoicesRoute,
  } = useVendorsRoute();

  const vendorProfileRoutes = [timelineRoute, agreementsRoute, relatedInvoicesRoute, documentsRoute];

  return (
    <ProtectedRouter basePath={getVendorsListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={FINANCE_VENDOR_LIST_READ}>
              <VendorsListPage />
            </GlobalProtectedRoute>
          }
        />

        {vendorProfileRoutes.map(path => (
          <Route
            key={path}
            path={path}
            element={
              <VendorSecurityContext permissionToCheck={VENDOR_READ}>
                <VendorDocumentContextTemplate>
                  <VendorProfile />
                </VendorDocumentContextTemplate>
              </VendorSecurityContext>
            }
          />
        ))}

        <Route
          path={documentsRoute}
          element={
            <VendorSecurityContext permissionToCheck={READ_VENDOR_DOCUMENTS}>
              <VendorDocumentContextTemplate>
                <VendorProfile />
              </VendorDocumentContextTemplate>
            </VendorSecurityContext>
          }
        />

        <Route path={singleEntityRoute} element={<Navigate to="timeline" replace />} />

        <Route
          path={complianceRoute}
          element={
            <VendorSecurityContext permissionToCheck={VENDOR_COMPLIANCE_REVIEW}>
              <VendorDocumentContextTemplate>
                <ComplianceVendorPage />
              </VendorDocumentContextTemplate>
            </VendorSecurityContext>
          }
        />
        <Route
          path={agreementRoute}
          element={
            <VendorSecurityContext permissionToCheck={VENDOR_FINALIZE}>
              <VendorDocumentContextTemplate>
                <AgreementVendorPage />
              </VendorDocumentContextTemplate>
            </VendorSecurityContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

VendorRouter.getRouterPath = getVendorsRouterPath;

export default VendorRouter;
